import { Routes } from '@angular/router';
import { RepairDocketComponent } from './repair-docket.component';

export const repairDocketRoutes: Routes = [
  {
    path: ':repairDocketId',
    component: RepairDocketComponent
  }
];
